export type ColorScheme =
  | "goldenHour"
  | "hazySundown"
  | "fierceSundown"
  | "sunrise"
  | "midMorning"
  | "afterNoon";

export const moduleNameToSchemaMap = new Map([
  ["Empowered Eating", "goldenHour"],
  ["The Mindset Shift", "hazySundown"],
  ["Movement for Life", "fierceSundown"],
  ["Long-Term Success", "afterNoon"],
  ["The Foundations", "sunrise"],
  ["Building Healthy Habits", "midMorning"]
]);
